<template>
    <div>
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="100px" @submit.native.prevent>
                <el-form-item label="创意名称" prop="text">
                    <el-input v-model.trim="formItem.text" clearable placeholder="请输入创意名称" @keyup.native="changeText"  class="word-limit-input" style="width:450px"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="$emit('close')" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import API from '@/api/marketManage/vivoBatch';
    export default {
        name: "IdeaSettingModal.vue",
        props:{
            text:String,
            cbs:{
                type:Object,
                default:()=>{},
            }
        },
        data(){
            let _this = this;
            const validateText = (rule, value, callback) => {
                if(/[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g.test(value)){
                    callback(new Error(_this.labelText+'不能输入表情'));
                }else {
                    callback();
                }
            };
            const text = _this.text || '';
            return {
                formItem:{
                    text,
                },
                submitLoading:false,
                rules:{
                    text: [
                        { required: true, message:'创意名称不能为空', trigger: 'blur' },
                        { validator: validateText, trigger: 'blur' }
                    ],
                },
            };
        },
        computed:{
           
        },
        methods:{
            async handleSubmit(){
                try{
                    this.submitLoading = true;
                    await this.$refs['form'].validate();
                    await this.cbs.onSubmit(this.formItem);
                    this.submitLoading = false;
                }catch(err){
                    this.submitLoading = false;
                }
            },
            changeText(){
                this.formItem.text = this.formItem.text.replace(/\s/g,'');
            },
        }
    }
</script>

<style scoped>

</style>
